import logo from './logo.svg';
import React from 'react';
import './App.css';
import Navbar from './components/navbar';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Footer from './components/footer';
import Home from './pages/home';
import About from './pages/about';
import Ourservices from './pages/ourservices';
import Ourfacilities from './pages/ourfacilities';
import Contactus from './pages/contactus';



function App() {
  return (
    <Router>
      
      <Routes>
        <Route exact path='/' element={<Home/>}/>
        <Route path='/Home' element={<Home/>}/>
        <Route path='/About' element={<About/>}/>
        <Route path='/OurServices' element={<Ourservices/>}/>
        <Route path='/Ourfacilities' element={<Ourfacilities/>}/>
        <Route path='/Contactus' element={<Contactus/>}/>
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
